<template>
  <div
    :class="[
      _.container,
      vertical && _.vertical,
      seckillStyle && _.seckillStyle,
    ]"
  >
    <div :class="_.price">
      <div :class="_.unit">¥</div>
      <div :class="_.value">{{ uniGoods.price }}</div>
    </div>
    <div
      v-if="!noCost && uniGoods.cost && uniGoods.cost !== uniGoods.price"
      :class="_.cost"
    >
      <div :class="_.unit">¥</div>
      <div :class="_.value">{{ uniGoods.cost }}</div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { makeUniGoods } from '@/utils'

  export default Vue.extend({
    props: {
      goods: {
        type: Object,
        required: true,
      },
      vertical: {
        type: Boolean,
        default: false,
      },
      noCost: {
        type: Boolean,
        default: false,
      },
      seckillStyle: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      uniGoods() {
        return makeUniGoods(this.goods)
      },
    },
  })
</script>

<style lang="scss" module>
  .container {
    flex-shrink: 0;
    display: flex;
    align-items: baseline;
    line-height: 1;

    .price {
      display: flex;
      align-items: baseline;
      font-size: 18px;
      font-weight: bold;
      color: #ff111c;

      .unit {
        font-size: 14px;
      }

      .value {
        margin-left: 1px;
      }
    }

    .cost {
      display: flex;
      align-items: baseline;
      margin-left: 4px;
      flex-shrink: 0;
      font-size: 12px;
      color: #bebebe;
      text-decoration: line-through;

      .value {
        margin-left: 1px;
      }
    }

    &.vertical {
      flex-direction: column;

      .cost {
        margin-left: 0;
        margin-top: 8px;
      }
    }

    &.seckillStyle {
      .price {
        font-size: 24px;
        color: #ffffff;

        .unit {
          font-size: 16px;
        }
      }

      .cost {
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
</style>
